import React, { useState,useEffect } from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
   useEffect(() => {
      
          document.title =
            "Privacy Policy - Embarque Services";
      
        }, []);

  return (

    <section className="privacy-policy-section">
      <br/>
  <div className="privacy-policy-container"><br/><br/><br></br>

    <h1>Privacy Policy</h1>

    <p>
      At <strong>Embarque Services</strong>, we respect your privacy and
      are committed to handling the personal information you provide to us
      responsibly. This policy explains how information may be collected
      and used when you contact us or request our home appliance services.
    </p>


    {/* PERSONAL INFORMATION */}

    <h2>Why We Collect Your Personal Information</h2>

    <p>
      When you contact us or request a service, we may collect information
      such as your <strong>Name, Phone Number, Email Address, Service Address</strong>,
      and details about your appliance or service requirement.
    </p>

    <ul>
      <li>
        <strong>Service Booking:</strong> To register and arrange your
        appliance service request.
      </li>

      <li>
        <strong>Appointment Communication:</strong> To contact you regarding
        scheduling and service updates.
      </li>

      <li>
        <strong>Customer Support:</strong> To respond to questions related
        to your service request.
      </li>

      <li>
        <strong>Service Records:</strong> To maintain relevant records of
        completed or requested services.
      </li>
    </ul>


    {/* DATA SECURITY */}

    <h2>Your Data Security</h2>

    <p>
      We take reasonable measures to protect the personal information
      provided to us. Customer information is used for legitimate
      service-related and business purposes.
    </p>

    <p>
      We do not sell or rent your personal information to third parties.
      Information may be shared when reasonably necessary to fulfil a
      requested service, operate our website, comply with applicable law,
      or work with service providers supporting our business operations.
    </p>


    {/* PROTECTION */}

    <h2>How We Protect Your Information</h2>

    <p>
      We use reasonable administrative and technical measures to protect
      customer information from unauthorized access, misuse, or disclosure.
      However, no internet-based system or electronic storage method can
      guarantee complete security.
    </p>


    


    {/* CONTACT */}

    <h2>Contact Us</h2>

    <p>
      If you have questions about this Privacy Policy, your personal
      information, or a refund or cancellation request, please contact us:
    </p>

    <p>
      <strong>Embarque Services</strong>
      <br />
      90/48, Heera Nagar Thoppucolony,
      <br />
      Madurai,
      <br />
      Madurai South,
      <br />
      Tamil Nadu - 625001
    </p>

    <p>
      <strong>Email:</strong>{" "}
      <a href="mailto:embarque.ads@gmail.com">
        embarque.ads@gmail.com
      </a>
    </p>

    <p>
      <strong>Phone:</strong>{" "}
      <a href="tel:+919363929984">
        +91 93639 29984
      </a>
    </p>

  </div>
</section>


  );
}

export default PrivacyPolicy;